import { CountryData } from '../types';

// Main countries used - Germany first, then alphabetical
// Flag is the country code which will be used with country-flag-icons library
export const countryPickerData: CountryData[] = [
  {
    key: 'DE',
    callingCode: '49',
    flag: 'DE',
    name: 'Germany',
    name_DE: 'Deutschland',
    maxLength: 15,
  },
  {
    key: 'AT',
    callingCode: '43',
    flag: 'AT',
    name: 'Austria',
    name_DE: 'Österreich',
    maxLength: 13,
  },
  {
    key: 'CH',
    callingCode: '41',
    flag: 'CH',
    name: 'Switzerland',
    name_DE: 'Schweiz',
    maxLength: 12,
  },
  {
    key: 'NL',
    callingCode: '31',
    flag: 'NL',
    name: 'Netherlands',
    name_DE: 'Niederlande',
    maxLength: 10,
  },
  {
    key: 'BE',
    callingCode: '32',
    flag: 'BE',
    name: 'Belgium',
    name_DE: 'Belgien',
    maxLength: 9,
  },
  {
    key: 'FR',
    callingCode: '33',
    flag: 'FR',
    name: 'France',
    name_DE: 'Frankreich',
    maxLength: 10,
  },
  {
    key: 'IT',
    callingCode: '39',
    flag: 'IT',
    name: 'Italy',
    name_DE: 'Italien',
    maxLength: 11,
  },
  {
    key: 'PL',
    callingCode: '48',
    flag: 'PL',
    name: 'Poland',
    name_DE: 'Polen',
    maxLength: 9,
  },
  {
    key: 'ES',
    callingCode: '34',
    flag: 'ES',
    name: 'Spain',
    name_DE: 'Spanien',
    maxLength: 9,
  },
  {
    key: 'GB',
    callingCode: '44',
    flag: 'GB',
    name: 'United Kingdom',
    name_DE: 'Vereinigtes Königreich',
    maxLength: 11,
  },
];

export const getCountryByCode = (code: string): CountryData | undefined => {
  return countryPickerData.find((country) => country.key === code);
};

export default countryPickerData;
